<template>
  <div class="news-all">
    <div class="title">
      <span class="time">
        06.17
        <br />2016
      </span>
      <span class="tiel">未来的独角兽：美菜荣获“创业邦中国年度创新成长企业100强”</span>
    </div>
    <div class="mat-content">
      <p align="center">
        <img
          src="https://img-oss.yunshanmeicai.com/cfile/86a12170f4a3688e67eac15e1d89e9c4.jpg"
          width="640"
        />
      </p>
      <div class="tet-js">
        2016年1月9日，“创业邦100未来领袖峰会”在北京国际饭店隆重举行。北京云杉信息技术有限公司（美菜网）荣获2015年“创业邦100－中国年度创新成长企业100强”。
        <br />
        <br />创业邦100榜单已推出6年，最终入选的公司，都是该年度最具潜力的创新公司，他们不仅揭示年度创业趋势，更成为推动中国创新发展的推动力。6年来，昔日上榜企业，奇虎360、京东、迅雷已纷纷成功上市。而曾经荣登榜单的乐视、知乎、滴滴快的等公司已成为今日耀眼的独角兽。
        <br />
        <br />对于美菜而言，这家定位于农产品O2O的企业来说，2015年的表现可谓风生水起：已顺利完成四轮融资，累计融资金额已超10亿人民币。自建仓储、物流、逐步实现源头采购，稳扎稳打，纵深上下游，包揽供应链，一路风生水起，惹人注目。2016年计划将覆盖到100个城市。而在新年伊始，美菜网又打出“任性低价，不怕事儿大”的口号，热推“1.10美菜节——餐饮购物周“。据悉，本次活动将从2016年1月10日起，持续5天。面向全国近千万中小餐饮商家，整合国内众多优秀供应商资源、数百家农村合作社及产地直供，从生鲜蔬果、肉禽蛋类到米面粮油、调料酒水，以全品类、超低价，结合各类线上优惠及线下推广活动，倾力打造国内首个互联网农产品B2B网购盛典。这无论是对于美菜自身，还是对整个行业而言，都具有积极和引领意义的。
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "new-a1"
};
</script>

<style lang="scss" scoped>
</style>
